// extracted by mini-css-extract-plugin
module.exports = {"button":"_3pB_a","icon":"_3foZ5","facebook":"_1SqwF","twitter":"_20BuV","link":"_2_Aq4","share":"_2S0xI"};